// Pagina publica /trocas-e-devolucoes — Politica de Troca e Devolucao. Sem login.
// Onda Google camada 1 (item que mais pesa na "Deturpacao" do Merchant).
// Politica: defeito = garantia legal 90d; arrependimento = 7d com NF, gera credito/troca.
import { PaginaInstitucional, Secao } from './PaginaInstitucional';
import { LinksWhatsapp } from './LinksWhatsapp';

const ATUALIZADO_EM = '27 de junho de 2026';

export function CatalogoPublicoTrocas() {
  return (
    <PaginaInstitucional
      subtitulo="Trocas e Devolucoes"
      titulo="Politica de Troca e Devolucao"
      atualizadoEm={ATUALIZADO_EM}
    >
      <p className="mt-4 text-sm leading-relaxed text-gray-700">
        Na Fio de Cobre as compras sao feitas presencialmente, na nossa loja em Sao
        Luis de Montes Belos / GO, sempre com emissao de nota fiscal. Esta politica
        explica como funcionam as trocas e devolucoes dos produtos adquiridos conosco.
      </p>

      <Secao titulo="1. Troca por defeito (garantia)">
        <p>
          Todo produto tem garantia contra defeitos de fabricacao, conforme o Codigo
          de Defesa do Consumidor (Lei n. 8.078/1990). Para produtos duraveis, o prazo
          para reclamar de um defeito aparente e de <strong>90 dias</strong> a partir
          da compra.
        </p>
        <p>
          Constatado o defeito, a loja podera reparar o produto, substitui-lo por
          outro igual ou equivalente, ou restituir o valor pago, conforme o caso.
          Basta trazer o produto a loja com a nota fiscal.
        </p>
      </Secao>

      <Secao titulo="2. Troca por arrependimento ou escolha errada">
        <p>
          Embora a compra seja presencial — situacao em que a troca por arrependimento
          nao e obrigatoria por lei — a Fio de Cobre aceita a troca por cortesia, desde
          que cumpridas todas as condicoes abaixo:
        </p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Prazo de ate <strong>7 dias corridos</strong> a partir da data da compra;</li>
          <li>Apresentacao da <strong>nota fiscal</strong> de compra;</li>
          <li>
            Produto <strong>sem uso</strong>, em perfeito estado, na{' '}
            <strong>embalagem original</strong> e com todos os acessorios.
          </li>
        </ul>
        <p>
          Atendidas as condicoes, a troca gera um <strong>credito</strong> de mesmo
          valor para uso na loja, ou a substituicao por outro produto. Nesse caso de
          arrependimento, nao ha devolucao em dinheiro.
        </p>
      </Secao>

      <Secao titulo="3. Itens que nao podem ser trocados">
        <p>
          <strong>
            Cabos e fios eletricos nao tem troca nem devolucao por arrependimento ou
            escolha do cliente
          </strong>{' '}
          — cortados na medida ou em rolo. Por seguranca e higiene, uma vez vendidos
          eles nao retornam ao estoque.
        </p>
        <p>Tambem nao aceitamos troca por arrependimento de:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Produtos feitos sob encomenda ou pedidos especiais;</li>
          <li>Produtos com sinais de uso, instalacao ou avaria causada apos a compra.</li>
        </ul>
        <p>
          A garantia legal contra defeito de fabricacao (item 1) continua valendo
          normalmente para todos os produtos, inclusive cabos e fios — defeito de
          fabricacao a loja troca ou conserta dentro da lei.
        </p>
      </Secao>

      <Secao titulo="4. Como solicitar">
        <p>
          Procure a loja com o produto e a nota fiscal, ou fale com a gente antes pelo
          WhatsApp <LinksWhatsapp className="font-medium" style={{ color: '#b45309' }} />
          . Nossa equipe orienta o passo a passo e confere as condicoes da troca.
        </p>
      </Secao>
    </PaginaInstitucional>
  );
}
